import { render, staticRenderFns } from "./nutritionAndFeeding.vue?vue&type=template&id=6b9b0a88&"
import script from "./nutritionAndFeeding.vue?vue&type=script&lang=js&"
export * from "./nutritionAndFeeding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports